import moment from 'moment';
import axios from 'axios';
import { apiEndpoint } from '../../settings';
import types from '../actionTypes';
import { toast } from 'react-toastify';
import { redirect } from './app';

export const editTest = (test) => {
	return (dispatch) => {
		dispatch(redirect('/edit-test'));
	};
}; //open test in editor

export const changeActiveTest = (test, isMobileSize) => {
	return (dispatch) => {
		if (test) {
			let dataFormData = new FormData();
			dataFormData.append('funkcja', 'pobierz_zapisany_test');
			dataFormData.append('id_testu', test['id_testu']);
			axios({
				method: 'post',
				url: apiEndpoint,
				data: dataFormData,
			})
				.then((res) => {
					if (Array.isArray(res.data)) {
						let tasks = res.data;
						tasks = tasks.map((task) => ({ ...task, png: `${task.swf.split('.swf')[0]}.png` }));
						const newTest = {
							id_testu: test['id_testu'],
							nazwa: test.nazwa,
							liczba_stron: test.liczba_stron,
							liczba_pytan: test.liczba_pytan,
							komentarz: test.komentarz,
							tasks,
							testPDF: null,
							keyPDF: null,
							wybrane_filtry: test['wybrane_filtry'],
						};
						dispatch({ type: types.SET_EDITOR_ACTIVE_TEST, groupModules: 'editor', test: newTest });
						dispatch({ type: types.SET_ACTIVE_TEST, id: test['id_testu'] });
						if (!!isMobileSize) {
							dispatch(editTest(test));
							dispatch({ type: types.OPEN_EDITOR_MODULES });
						}
					} else {
						throw Error(res.data);
					}
				})
				.catch((err) => {
					console.log(err);
					dispatch({ type: types.SET_EDITOR_ACTIVE_TEST, groupModules: 'editor', test: null });
					dispatch({ type: types.SET_ACTIVE_TEST, id: null });
				});
		} else {
			dispatch({ type: types.SET_EDITOR_ACTIVE_TEST, groupModules: 'editor', test: null });
			dispatch({ type: types.SET_ACTIVE_TEST, id: null });
		}
	};
};

export const resetActiveTest = () => {
	return (dispatch) => {
		dispatch({ type: types.SET_ACTIVE_TEST, id: null });
	};
};

export const sortTests = (status) => ({ type: types.SORT_TESTS, status });
export const saveTest = (test, userID) => {
	return (dispatch) => {
		let dataFormData = new FormData();
		dataFormData.append('funkcja', 'zapisz_test');
		dataFormData.append('id_uzytkownika', userID);
		dataFormData.append('nazwa_testu', test.nazwa);
		if (test['id_testu']) {
			dataFormData.append('id_testu', test['id_testu']);
		}
		dataFormData.append('liczba_stron', 0);
		dataFormData.append(
			'lista_pytan',
			test.tasks.map((task) => task['id_pytania'])
		);
		dataFormData.append('wybrane_filtry', JSON.stringify(test['wybrane_filtry']));
		axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.data.success) {
					toast.success(`Test został zapisany`, {
						closeButton: false,
						autoClose: 2500,
						hideProgressBar: true,
					});
					dispatch(getUserTests(userID));
					dispatch({ type: types.SET_ACTIVE_TEST, id: null });
					dispatch({ type: types.RESET_EDITOR });
					dispatch(redirect('/my-tests'));
					dispatch({ type: types.CLOSE_EDITOR_MODULES });
				} else {
					throw Error(res.data.reason);
				}
			})
			.catch((err) => {
				console.log(err);
				toast.error('Nie udało się zapisać testu', {
					closeButton: false,
					autoClose: 2500,
					hideProgressBar: true,
				});
				dispatch(getUserTests(userID));
				dispatch({ type: types.SET_ACTIVE_TEST, id: null });
				dispatch({ type: types.RESET_EDITOR });
				dispatch(redirect('/my-tests'));
				dispatch({ type: types.CLOSE_EDITOR_MODULES });
			});
	};
};

export const saveTestName = (testID, newName) => {
	if (testID) {
		let dataFormData = new FormData();
		dataFormData.append('funkcja', 'zapisz_nazwe_testu');
		dataFormData.append('id_testu', testID);
		dataFormData.append('nazwa_testu', newName);
		axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.data.success) {
					toast.success(`Nazwa testu została zmieniona`, {
						closeButton: false,
						autoClose: 2500,
						hideProgressBar: true,
					});
				} else {
					throw Error(res.data.reason);
				}
			})
			.catch((err) => {
				console.log(err);
				toast.error('Nie udało się zmienić nazwy. Spróbuj poźniej', {
					closeButton: false,
					autoClose: 2500,
					hideProgressBar: true,
				});
			});
	} else {
		return;
	}
};

export const deleteTest = (test, userID) => {
	return (dispatch) => {
		let dataFormData = new FormData();
		dataFormData.append('funkcja', 'usun_test');
		dataFormData.append('id_testu', test['id_testu']);
		axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.data.success) {
					toast.success(`Test ${test.nazwa} został usunięty`, {
						closeButton: false,
						autoClose: 2500,
						hideProgressBar: true,
					});
					dispatch({ type: types.DELETE_TEST, testID: test['id_testu'] });
					dispatch(getUserTests(userID));
					dispatch({ type: types.RESET_EDITOR });
				} else {
					toast.error('Nie udało się usunąć testu', {
						closeButton: false,
						autoClose: 2500,
						hideProgressBar: true,
					});
					throw Error(res.data.reason);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};
};

export const createTest = (userID) => {
	const test = {
		id: `user-${userID}_newTest-${userID * Math.floor(Math.random() * 100)}`,
		nazwa: '',
		przedmiot: '',
		testPDF: null,
		keyPDF: null,
		liczba_stron: 0,
		liczba_pytan: 0,
		komentarz: '',
		data: moment().format('YYYY-DD-MM HH:mm:ss'),
		dataUnix: moment().unix(),
		tasks: [],
	};

	return (dispatch) => {
		dispatch({ type: types.SET_EDITOR_ACTIVE_TEST, test });
		dispatch(redirect('/create-test'));
	};
};

export const getUserTests = (userID) => {
	return (dispatch) => {
		const dataFormData = new FormData();
		dataFormData.append('funkcja', 'pobierz_liste_testow');
		dataFormData.append('id_uzytkownika', userID);
		return axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (!Array.isArray(res.data) && !res.data.success) {
					// dispatch({ type: types.SET_API_ERROR, state: true });
					dispatch({ type: types.GET_USER_TESTS, tests: [] });
					throw Error(res.data);
				} else {
					const newTests = res.data.map((test) => ({
						...test,
						nazwa: test.nazwa,
						dataUnix: moment(test.data, 'YYYY-MM-DD HH:mm:ss').unix(),
					})); //add unix time field to test object
					dispatch({ type: types.GET_USER_TESTS, tests: newTests });
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};
};

export const checkArchiveTests = (userID) => {
	return (dispatch) => {
		const dataFormData = new FormData();
		dataFormData.append('funkcja', 'pobierz_liste_archiwalnych_testow');
		dataFormData.append('id_uzytkownika', userID);
		return axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.status === 200) {
					if (Array.isArray(res.data) && res.data.length > 0) {
						dispatch({ type: types.CHECK_ARCHIVE_TESTS, status: true });
					} else {
						dispatch({ type: types.CHECK_ARCHIVE_TESTS, status: false });
					}
				} else {
					throw Error(`Error status: ${res.status}`);
				}
			})
			.catch((err) => {
				console.log(err);
				dispatch({ type: types.CHECK_ARCHIVE_TESTS, status: false });
			});
	};
};

export const getArchiveTests = (userID) => {
	return (dispatch) => {
		dispatch({ type: types.GET_ARCHIVE_TESTS, isLoading: true });
		const dataFormData = new FormData();
		dataFormData.append('funkcja', 'pobierz_archiwalne_testy');
		dataFormData.append('id_uzytkownika', userID);
		return axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.data.success) {
					dispatch({ type: types.GET_ARCHIVE_TESTS, isLoading: false });
					const link = document.createElement('a');
					link.href = res.data.zip;
					link.target = '_self';
					document.body.appendChild(link);
					link.click();
					link.remove();
					// window.open(res.data.zip, '_self');
				} else {
					throw Error(`Error status: ${res.status}`);
				}
			})
			.catch((err) => {
				console.log(err);
				dispatch({ type: types.GET_ARCHIVE_TESTS, isLoading: false });
			});
	};
};
